var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { AwsUi } from '../../../core/runtime/src';
import LegacyClassBuilder from '../../../core/utils/src/class-builders/legacy';
var lastGeneratedId = 0;
function nextGeneratedId(componentName) {
    return componentName + "-" + lastGeneratedId++;
}
export var callbacks = {
    initialized: function () {
        this.__defaultControlId = nextGeneratedId(this.__componentName);
        if (!this.controlId) {
            this.controlId = this.__defaultControlId;
        }
    }
};
export function render(component, h, svg) {
    var componentName = component.__componentName;
    var controlId = component.controlId || component.__defaultControlId;
    var inputAttributes = h.copyDefined({
        'override-focus': true,
        checked: component.checked,
        disabled: component.disabled,
        id: controlId,
        name: component.name,
        onfocus: function () { return component.__fireEvent('focus'); },
        onblur: function () { return component.__fireEvent('blur'); },
        onchange: function (nativeEvent) {
            component.checked = nativeEvent.target.checked;
            component.indeterminate = false;
            component.__fireEvent('change', { checked: component.checked });
        },
        'aria-describedby': component.ariaDescribedby ? component.ariaDescribedby : undefined,
        'aria-labelledby': component.ariaLabelledby ? controlId + "-label " + component.ariaLabelledby : undefined,
        'aria-label': component.ariaLabel
    });
    var cb = new LegacyClassBuilder(component)
        .addClass(componentName)
        .addComponentClass('disabled', component.disabled)
        .addComponentClass('checked', component.checked)
        .addComponentClass('indeterminate', component.indeterminate);
    var labelAttributes = h.copyDefined({
        className: cb.toClassName(),
        for: controlId,
        'aria-disabled': component.disabled ? 'true' : undefined,
        id: controlId + "-label"
    });
    return (AwsUi.__createElement("label", __assign({}, labelAttributes),
        AwsUi.__createElement("input", __assign({ className: componentName + "-native-input", type: "checkbox" }, inputAttributes)),
        AwsUi.__createElement("div", { className: componentName + "-styled-box" }, svg),
        AwsUi.__createElement("div", null,
            h.region('label', 'div', { className: componentName + "-label" }),
            h.region('description', 'div', { className: componentName + "-description" }))));
}
//# sourceMappingURL=common.js.map